// extracted by mini-css-extract-plugin
export default {"container":"splash_container__KFDuV","content":"splash_content__29cNG","demoContainer":"splash_demoContainer__1kWfU"};